export const UPDATE_ACCESSTOKEN_ACITON = 'UPDATE_ACCESSTOKEN_ACITON' as const;

export const UPDATE_REFESHTOKEN_ACTION = 'UPDATE_REFESHTOKEN_ACTION';
